import { default as React, PropTypes } from 'react';

class AddToArena extends React.Component {
  render() {
    return (
      <svg version="1.1" id="Layer_1" x="0px" y="0px" width="37.367px" height="20.448px" viewBox="0 0 37.367 20.448">
        <g>
          <g>
            <g>
              <path d="M24.377,15.334c-0.231,0.177-0.607,0.177-0.83,0l-3.279-2.52c-0.227-0.178-0.228-0.468-0.004-0.648l3.285-2.586
                c0.225-0.175,0.598-0.175,0.825,0l3.282,2.586c0.225,0.18,0.225,0.47-0.004,0.648L24.377,15.334z M37.111,9.207
                c0.227-0.18,0.32-0.481,0.21-0.669c-0.111-0.193-0.421-0.258-0.694-0.151l-4.419,1.76c-0.27,0.109-0.524-0.038-0.561-0.326
                L30.982,5.1c-0.043-0.283-0.26-0.52-0.476-0.52c-0.228,0-0.445,0.237-0.482,0.52l-0.663,4.72
                c-0.043,0.288-0.295,0.435-0.565,0.326l-4.348-1.733c-0.27-0.107-0.712-0.107-0.978,0l-4.351,1.731
                c-0.266,0.109-0.52-0.037-0.557-0.326l-0.667-4.72c-0.041-0.281-0.252-0.519-0.475-0.519c-0.229,0-0.446,0.238-0.485,0.519
                l-0.663,4.72c-0.039,0.289-0.295,0.435-0.561,0.326l-4.416-1.759c-0.274-0.106-0.582-0.042-0.698,0.151
                c-0.115,0.189-0.017,0.49,0.211,0.668l3.719,2.92c0.227,0.179,0.227,0.471,0,0.65l-3.719,2.924
                c-0.229,0.178-0.326,0.497-0.211,0.712c0.116,0.21,0.425,0.295,0.698,0.186l4.371-1.758c0.274-0.105,0.52,0.039,0.563,0.324
                l0.629,4.761c0.043,0.287,0.295,0.524,0.563,0.524c0.266,0,0.52-0.237,0.549-0.524l0.634-4.761
                c0.039-0.285,0.295-0.429,0.559-0.324l4.308,1.733c0.267,0.105,0.708,0.105,0.978,0l4.305-1.732
                c0.268-0.106,0.524,0.039,0.557,0.325l0.636,4.759c0.039,0.289,0.289,0.524,0.56,0.524c0.264,0,0.515-0.235,0.55-0.524
                l0.631-4.759c0.043-0.286,0.293-0.431,0.563-0.325l4.378,1.758c0.273,0.108,0.583,0.022,0.694-0.187
                c0.111-0.215,0.017-0.533-0.21-0.711l-3.719-2.924c-0.225-0.179-0.225-0.47,0-0.65L37.111,9.207z"/>
            </g>
          </g>
          <g>
            <path d="M4.652,11.298V6.611H0V4.652h4.652V0h1.982v4.652h4.651v1.959H6.635v4.687H4.652z"/>
          </g>
        </g>
      </svg>
    );
  }
}

export default AddToArena;


// WEBPACK FOOTER //
// ./common/components/save_path_contents/add_to_arena.js